export default __webpack_public_path__ + "static/media/user.e969db4a.svg";